import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { LanguageService } from '@fcom/ui-translate';
import { enumValues, isNotEmpty, isPresent } from '@fcom/utils';

import { SortBy } from '../../../interfaces';

export interface SortOption {
  value: SortBy;
  label?: string;
}

@Component({
  selector: 'fin-ticket-selection-sort-by',
  styleUrls: ['./ticket-selection-sort-by.component.scss'],
  templateUrl: './ticket-selection-sort-by.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketSelectionSortByComponent implements OnInit {
  @Input()
  selectedSortBy$: Observable<SortBy>;

  @Output()
  sortByChange: EventEmitter<SortBy> = new EventEmitter();

  sortOptions$: Observable<SortOption[]>;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    const sortByValues: string[] = enumValues(SortBy);
    const translationKeys: string[] = sortByValues
      .filter((key) => key !== SortBy.BEST)
      .map((key: string) => `ticketSelection.sort.${key}`);
    this.sortOptions$ = this.languageService.translateMultiple(translationKeys).pipe(
      map((labels: string[]): SortOption[] =>
        labels
          .map((label: string, i: number) => ({ value: sortByValues[i] as SortBy, label }))
          .filter((option: SortOption) => isPresent(option.label))
      ),
      filter(isNotEmpty)
    );
  }
}
